import { render, staticRenderFns } from "./TxDetail.vue?vue&type=template&id=7894895c&scoped=true&"
import script from "./TxDetail.vue?vue&type=script&lang=js&"
export * from "./TxDetail.vue?vue&type=script&lang=js&"
import style0 from "./TxDetail.vue?vue&type=style&index=0&id=7894895c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894895c",
  null
  
)

export default component.exports